import React, { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Input from "../../../../components/Input";
import Button from "../../../../components/Button";
import { getApi, postApi } from "../../../../utils/ServiceManger";
import styles from "./addDevice.module.scss";
import homeStyles from "../../home.module.scss";

const AddDevice = ({ show, setShow }) => {
  const navigate = useNavigate();
  const [devices, setDevices] = useState([]);

  const getDevices = () => {
    getApi(
      "devices",
      (res) => {
        if (res?.status) {
          setDevices(res?.data?.devices || []);
        }
      },
      () => {}
    );
  };

  useEffect(() => {
    getDevices();
  }, []);

  const formik = useFormik({
    initialValues: { device_name: "", dev_id: "", passcode: "" },
    validationSchema: Yup.object().shape({
      device_name: Yup.string().trim().required("Please enter device name"),
      dev_id: Yup.string()
        .trim()
        .required("Please enter device ID")
        .matches(
          /^([0-9a-fA-F]{1,2}:){5}[0-9a-fA-F]{1,2}$/,
          "Enter a valid device ID (MAC address format, e.g. 78:3:6d:cd:18:b0)"
        ),
      passcode: Yup.string().trim().required("Please enter passcode"),
    }),
    onSubmit: (values, { resetForm }) => {
      const formData = new FormData();
      formData.append("device_name", values.device_name.trim());
      formData.append("dev_id", values.dev_id.trim());
      formData.append("passcode", values.passcode.trim());
      postApi(
        "devices/add",
        formData,
        (res) => {
          if (res?.status) {
            setDevices(res?.data?.devices || []);
            resetForm();
            setShow(false);
            toast.success("Device added successfully");
          } else if (res?.message === "Not valid token, Please log in first") {
            navigate("/login");
          } else {
            toast.error(res?.message || "Failed to add device");
          }
        },
        (err) => toast.error(err?.message?.toString() || "Something went wrong")
      );
    },
  });

  const close = () => {
    formik.resetForm();
    setShow(false);
  };

  return (
    <>
      <div className={styles.deviceSection}>
        <h6 className="typography--class-h6 font-face-gr grey70 mb-3">
          Devices
        </h6>
        {devices.length === 0 ? (
          <div className={styles.emptyDevices}>
            <p className="typography--class-caption grey30 m-0">
              No devices added yet. Click "Add Device" to register one.
            </p>
          </div>
        ) : (
          <div className={styles.deviceGrid}>
            {devices.map((d) => (
              <div key={d.id} className={styles.deviceCard}>
                <p className="typography--class-body cureousGrey fw-bold m-0">
                  {d.device_name || "Unnamed device"}
                </p>
                <p className={styles.deviceId}>{d.unique_id}</p>
                <p className="typography--class-footer m-0 mt-2">
                  <span
                    className={`${styles.statusDot} ${
                      d.state ? styles.statusConnected : styles.statusOffline
                    }`}
                  />
                  <span className={d.state ? "green" : "red"}>
                    {d.state ? "Connected" : "Offline"}
                  </span>
                </p>
              </div>
            ))}
          </div>
        )}
      </div>
      <Offcanvas
        placement="end"
        show={show}
        onHide={close}
        backdropClassName={homeStyles.Offcanvas}
      >
        <Offcanvas.Header bsPrefix={homeStyles.OffcanvasHeader} closeButton>
          <Offcanvas.Title
            className={`typography--class-h5 font-face-gr ${homeStyles.offCanvasTitle}`}
          >
            Add Device
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body bsPrefix="d-flex flex-column h-100">
          <div className="p-4 p-lg-5 d-flex flex-column gap-1 gap-lg-4">
            <Input
              label="*Device Name"
              id="device_name"
              type="text"
              placeholder="e.g. Bed 3 Sensor"
              value={formik.values.device_name}
              error={formik.touched.device_name && formik.errors.device_name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <Input
              label="*Device ID"
              id="dev_id"
              type="text"
              placeholder="78:3:6d:cd:18:b0"
              value={formik.values.dev_id}
              error={formik.touched.dev_id && formik.errors.dev_id}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <Input
              label="*Passcode"
              id="passcode"
              type="password"
              placeholder="Enter passcode"
              autoComplete="new-password"
              value={formik.values.passcode}
              error={formik.touched.passcode && formik.errors.passcode}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <div className="d-flex justify-content-evenly mt-2">
              <Button
                onClick={formik.handleSubmit}
                type="submit"
                text="Add Device"
              />
              <Button text="Cancel" onClick={close} variant="secondary" />
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default AddDevice;
